/// <reference path="../jquery/jquery.d.ts" />
/// <reference path="../app/common_member.ts" />

declare let SxcVideoPlayer : any;
declare let authHandler : any;
declare let d3 : any;

let myPageHandler = {

	init: function() {

		$("#myPage").on('click', '.gallery a, .morethumbnails a', myPageHandler.subPageLoader);

		$('body').keyup(function(e)
		{
			// Csak a képgalériánál!
			if ($('#myPageCont').find('.imagegallery').length === 0) return;

			if(e.keyCode === 37) {
				var url = $('#myPageContent').find('.imagegallery .prev').attr("href");
				myPageHandler.subPageLoader(false, url);
			} else if(e.keyCode === 39) {
				var url = $('#myPageContent').find('.imagegallery .next').attr("href");
				myPageHandler.subPageLoader(false, url);
			}
		});
	},

	addFav: function(perfid) {this._fav('add', perfid); return false;},
	delFav: function(perfid) {this._fav('del', perfid); return false;},

	_fav: function(method, perfid) {

		debug.log('myPageHandler::_fav', method, perfid);

		var $myPage = $('#myPage');
		$myPage.find('.menu .addFav')[method=='add' ? 'hide' : 'show']();
		$myPage.find('.menu .delFav')[method=='del' ? 'hide' : 'show']();

		$.getJSON('/callback', {command: method + 'FavPerformer', perfid: perfid}, function(r){
			debug.log('callback::' + method + "FavPerformer", perfid, r);
			if (r.success) {
				var cnt = $('.favourites .popupMenu ul');
				cnt.empty().append(r.html);
			}
		});
	},

	getPage: function() {
		var page = $('#myPageContentMain').find('div:eq(0)').data('page');
		if (!page) page = false;
		return page;
	},

	showLogin: function(url) {
		authHandler.showJoin(url);
	},

	subPageLoader: function (e, url = undefined)
	{
		debug.log("mypagehandler.subPageLoader", e, $(e.target).attr('href'), url);
		if (typeof url === 'undefined') {
			let $link = $(e.target).closest("a");
			if ($link.data("noajax")) return;
			url = $link.attr('href');
		}

		var ajaxurl = url + '?ajax=page';

		$('#myPageContentMain').load(ajaxurl, function(r,s,x) {

			if (s === 'error') {
				if (x.status === 403) myPageHandler.showLogin(url);
				if (x.status === 405) location.href="/easterpromo";
				else if (x.status === 404) location.href = location.href.split('/').slice(0,-1).join('/');
			}
			$('#mypageContent').append('<div style="clear:both"></div>');
			var $sideBar = $('#myPageSideBar');
			$sideBar.find('.menu li')
				.removeClass('active');
			$sideBar.find('.menu li[data-subloc=' + myPageHandler.getPage()+']')
				.addClass('active');
		});
		return false;
	}
};

var miniTeaserHandler = {

	params: null,
	player: null,

	init: function(vpParams, data)
	{
		const $button = $('#miniTeaserButton');

		console.log("miniTeaser", vpParams, data);

		if (data) {
			var videoParams = {
				id: data.id,
				autoplay: true,
				muted: false,
				template: "mini",
				callbacks: {
					onRegister: function() {
						authHandler.showJoin();
					},
					onClose: () => {
						this.player.$destroy();
						$('#miniTeaser').remove();
						$button.show();

						$("<div id='miniTeaser'>").insertAfter($button);

						// TODO: Destroy the remains of the player
					},
					onSquare: () => {
						location.href = data.teaserURL;
					}
				}
			};

			$button.click((e) =>
			{
				e.preventDefault();
				const node = document.getElementById("miniTeaser");
				$button.hide();
				$('#miniTeaser').show();
				this.player = SxcVideoPlayer.init(node, vpParams, videoParams);
				return false;
			})
		}

	},
};

var creditHandler = {

	inCreditMode: false,

	init: function() {

		$("#creditContainer").on('click', '.close', function(e){
			debug.log('#creditContainer.close::click');
			creditHandler.inCreditMode = false;
			creditHandler.close();
			return false;
		});

		$("#myPage").find("ul.menu").on('click', 'li.active a', function(e){
			creditHandler.close();
			return false;
		});
	},

	showTopupPanel: function(target, url) {
		topupHandler.show("chat", "creditcard", 1000);
	},

	showFrame: function(url)
	{
		$('#creditContainer')
			.show()
			.find('.iframe')
				.height(750)
				.show()
				.attr('src', url);
	},

	close: function() {

		let page = myPageHandler.getPage();

		switch (page) {
			case 'teaser':
			case false:
			case 'videos':
				if (typeof videoHandler !== 'undefined') {
					let hasVideo = videoHandler.unSetMini();
					if (hasVideo) break;
				}
				break;
			default:
				$('.layoutContent').show();
		}

		$('#creditContainer')
			.hide()
			.find('.iframe').attr('src', 'about:blank').hide();
	}
};

interface GiftItem {
	name: string;
	id: string;
	price: number;
	priceText: string;
	image: string;
	visible ?: boolean;
	expired ?: boolean;
	covered ?: boolean;

	params ?: {

	}
}

interface GiftItems {
	[k: string]: GiftItem;
}

class GiftPage
{
	private TAG = "[GiftPage]";
	private isLoading = false;
	private $dialog: JQuery;
	private giftID: string;
	private hideTimer: any;

	constructor(private perfID : number, public gifts : Array<GiftItem>, private $root : JQuery)
	{
		debug.log(this.TAG, "[constructor]", gifts);
		this.init();
		this.checkHash();
		//this.showDialogFor(this.$root.find(".gift[data-id=cocktail_orange]"));
		//setTimeout(() => {
		//	this.showResult("gift", true, false);
		//}, 700);
	}

	init()
	{
		this.$root.find(".gift").click((e) =>
		{
			if (this.isLoading) {
				debug.log(this.TAG, "Loading...");
				return;
			}

			var $gift = $(e.currentTarget).closest(".gift");
			var giftID = $gift.data("id");
			var currentGift = this.giftID;

			this.hideDialog(() => {
				if (currentGift !== giftID) {
					this.showDialogFor($gift);
				}
			});
		})
	}

	checkHash()
	{
		if (window.location.hash.substr(0, 6) === "#gift_")
		{
			var giftID = window.location.hash.substr(6);
			if (giftID in this.gifts) {

				var $gift = this.$root.find(".gift[data-id=" + giftID + "]");

				$(() => {
					$(window).scrollTop(
						$gift.offset().top -10
					);
					this.showDialogFor($gift);
				});
			}
		}
	}

	hideDialog(onHidden=null)
	{
		if (this.hideTimer) clearTimeout(this.hideTimer);

		if (this.$dialog)
		{
			if ("ontransitionend" in window )
			{
				this.$root.find(".gift[data-id="+this.giftID+"]").removeClass("selected");
				this.isLoading = true;
				this.$dialog.on("transitionend", () =>
				{
					this.isLoading = false;
					this.$dialog.remove();
					this.$dialog = null;
					this.giftID = null;
					if (onHidden) onHidden();
				});
				this.$dialog.css("height", 0);
			}
			else
			{
				this.$dialog.remove();
				this.$dialog = null;
				this.giftID = null;
				if (onHidden) onHidden();
			}
		}
		else
		{
			if (onHidden) onHidden();
		}
	}

	showDialogFor($gift: JQuery)
	{
		var gift = this.gifts[$gift.data("id")];

		var itemsInRow = 5;

		var dialogPos = Math.min(
			Math.floor($gift.index() / itemsInRow) * itemsInRow + (itemsInRow - 1),
			$gift.parent().find(".gift").length - 1 // Count of gifts in the cat.
		);

		this.giftID = gift.id;
		this.$dialog = this.$root.find(".dialog-template").clone();

		$gift.addClass("selected");

		this.$dialog
			.removeClass("dialog-template")
			.addClass("dialog");

		$gift.parent().find(".gift").eq(dialogPos).after(this.$dialog);

		// Prepeare dialog

		// Position the arrow on the dialog at the gift itself
		var giftBoxWidth = $gift.parent().width() / itemsInRow;
		var arrowPos =  giftBoxWidth * ($gift.index()%itemsInRow) + (giftBoxWidth / 2);
		this.$dialog.find(".arrow").css("left", arrowPos);


		// Update data in the dialog
		var $title = this.$dialog.find("h4.title");
		$title.text($title.text().replace("{{gift}}", gift.name));

		// Purchase button
		var $purchase = this.$dialog.find(".button.purchase");

		$purchase.val(
			$purchase.val()
				.replace("{{gift}}", gift.name)
				.replace("{{price}}", gift.priceText)
		);

		$purchase.click(() =>
		{
			this.showContent("loading");
			var message = this.$dialog.find("textarea").val().trim();

			this.purchaseWrapper(() => {
				giftHandler.purchase(this.giftID, message, this.perfID, (r) => {
				// this.dummyPurchase(1000, false, "ooc", (r) => {
					this.showResult("gift", r.success, r.reason);
					creditDisplayHandler.update();
				});
			});
		});

		// OK and Cancel button acts same...
		this.$dialog.on("click", ".button.cancel, .button.ok", () => {this.hideDialog()});

		this.$dialog.find(" img").attr("src", giftHandler.getImageURL(gift.id));
		this.$dialog.css("height", this.$dialog.find(".inner").outerHeight());

		this.showContent("message");
		this.$dialog.find("textarea").focus();
	}

	/**
	 * The only purpouse of this method is to wrap the purchase in a 2 sec timeout so the
	 * loading animation would show :)
	 * @param callback
	 */
	purchaseWrapper(callback)
	{
		setTimeout(() => callback(), 1000);
	}

	dummyPurchase(timeout: number, success: boolean, reason: string, callback): void
	{
		setTimeout(() => {
			callback({success: success, reason: reason})
		}, timeout);
	}

	showContent(content : string)
	{
		this.$dialog.removeClass("loading message result").addClass(content);
		//var $contents = this.$root.find(".content");
		//$contents.css("display", "none");
		//$contents.filter("." + content).css("display", "table-cell");
	}

	showResult(itemType, success, reason)
	{
		this.showContent("result");
		this.$dialog.addClass(success ? "result-success" : "result-error");

		if (success) {
			var message = this.$dialog.data(itemType + "-success");

			this.hideTimer = setTimeout(()=>{
				this.hideDialog();
			}, 6000);

		} else {
			var message = this.$dialog.data(itemType + "-" + reason);
			if (!message) message = this.$dialog.data(itemType + "-technical");

			if (reason === "ooc") {
				this.$dialog.find(".button.cancel").click(() => {
					securionPayHandler.showTopup();
				});
			}
		}

		message = message.replace("{{gift}}", this.gifts[this.giftID].name);

		this.$dialog.find("div.message span.msg").empty().text(message);
	}
}

class GiftBlock
{
	protected TAG = "[GiftBlock]";
	protected isLoading = false;
	protected $dialog: JQuery;
	protected giftID: string;
	protected hideTimer: any;

	constructor(protected $root : JQuery,
	            public gifts : GiftItem[],
	            protected perfID: number,
	            private loggedIn : boolean
	)
	{
		debug.log(this.TAG, "[constructor]", gifts);
		this.init();
		this.checkHash();
	}

	init()
	{
		this.$root.find(".gift-wrapper:not(.gift-expired) .gift").click((e) =>
		{
			if (this.isLoading) {
				debug.log(this.TAG, "Loading...");
				return;
			}

			if (!this.loggedIn) {
				authHandler.showJoin();
				return;
			}

            let $target = $(e.currentTarget);

            if (!$target.data("id")) {
	            $target = $target.closest(".gift");
            }

            let $gift = $target;
            let giftID = $gift.data("id");
			let currentGift = this.giftID;

			this.hideDialog(() => {
				if (!currentGift || currentGift !== giftID) {
					this.showDialogFor($gift);
				}
			});
		})
	}

	checkHash()
	{
		if (window.location.hash.substr(0, 6) === "#gift_")
		{
			let giftID = window.location.hash.substr(6);
			if (giftID in this.gifts) {

				let $gift = this.$root.find(".gift[data-id=" + giftID + "]");

				$(() => {
					$(window).scrollTop(
						$gift.offset().top -10
					);
					this.showDialogFor($gift);
				});
			}
		}
	}

	hideDialog(onHidden=null)
	{
		if (this.hideTimer) clearTimeout(this.hideTimer);

		this.$root.removeClass("giftblock-open");

		if (this.$dialog)
		{
			if ("ontransitionend" in window )
			{
				this.$root.find(".gift[data-id="+this.giftID+"]").removeClass("selected");
				this.isLoading = true;
				this.$dialog.on("transitionend", () =>
				{
					this.isLoading = false;
					this.$dialog.remove();
					this.$dialog = null;
					this.giftID = null;
					if (onHidden) onHidden();
				});
				this.$dialog.css("height", 0);
			}
			else
			{
				this.$dialog.remove();
				this.$dialog = null;
				this.giftID = null;
				if (onHidden) onHidden();
			}
		}
		else
		{
			if (onHidden) onHidden();
		}
	}

	showDialogFor($gift: JQuery)
	{
		let $wrapper = $gift.parent();
		let $root = $wrapper.parent();

		let gift = this.gifts[$gift.data("id")];

		let itemsInRow = 6;

		debug.log("i" , $root, $wrapper.index(), $root.find(".gift").length - 1);
		let  dialogPos = Math.min(
			Math.floor($wrapper.index() / itemsInRow) * itemsInRow + (itemsInRow - 1),
			$root.find(".gift-wrapper").length - 1 // Count of gifts in the cat.
		);

		this.giftID = gift.id;
		this.$dialog = this.$root.find(".dialog-template").clone();

		$gift.addClass("selected");

		this.$dialog
			.removeClass("dialog-template")
			.addClass("dialog");

		$root.find(".gift-wrapper").eq(dialogPos).after(this.$dialog);

		// Prepeare dialog

		// Position the arrow on the dialog at the gift itself
		let giftBoxWidth = $root.width() / itemsInRow;
		let arrowPos =  giftBoxWidth * ($wrapper.index() % itemsInRow) + (giftBoxWidth / 2);
		this.$dialog.find(".arrow").css("left", arrowPos);

		// Update data in the dialog
		let  $title = this.$dialog.find("h4.title");
		$title.text($title.text().replace("{{gift}}", gift.name));

		// Purchase button
		let  $purchase = this.$dialog.find(".button.purchase");

		$purchase.val(
			$purchase.val()
				.replace("{{gift}}", gift.name)
				.replace("{{price}}", gift.priceText)
		);

		$purchase.click(() =>
		{
			this.showContent("loading");
			let  message = this.$dialog.find("textarea").val().trim();

			this.purchaseWrapper(() => {
				giftHandler.purchase(this.giftID, message, this.perfID, (r) => {
					this.showResult("gift", r.success, r.reason);
					creditDisplayHandler.update();
				});
			});
		});

		// OK and Cancel button acts same...
		this.$dialog.on("click", ".button.cancel, .button.ok", () => {this.hideDialog()});

		this.$dialog.find(" img").attr("src", giftHandler.getImageURL(gift.id));
		this.$dialog.css("height", this.$dialog.find(".inner").outerHeight());

		this.showContent("message");
		this.$dialog.find("textarea").focus();
		this.$root.addClass("giftblock-open");

	}

	/**
	 * The only purpouse of this method is to wrap the purchase in a 2 sec timeout so the
	 * loading animation would show :)
	 * @param callback
	 */
	purchaseWrapper(callback)
	{
		setTimeout(() => callback(), 1000);
	}

	dummyPurchase(timeout: number, success: boolean, reason: string, callback): void
	{
		setTimeout(() => {
			callback({success: success, reason: reason})
		}, timeout);
	}

	showContent(content : string)
	{
		this.$dialog.removeClass("loading message result").addClass(content);
		//var $contents = this.$root.find(".content");
		//$contents.css("display", "none");
		//$contents.filter("." + content).css("display", "table-cell");
	}

	showResult(itemType, success, reason)
	{
		this.showContent("result");
		this.$dialog.addClass(success ? "result-success" : "result-error");

		let message;

		if (success) {
			message = this.$dialog.data(itemType + "-success");

			this.hideTimer = setTimeout(()=>{
				this.hideDialog();
			}, 6000);

		} else {
			message = this.$dialog.data(itemType + "-" + reason);
			if (!message) message = this.$dialog.data(itemType + "-technical");

			if (reason === "ooc") {
				this.$dialog.find(".button.cancel").click(() => {
					securionPayHandler.showTopup();
				});
			}
		}

		message = message.replace("{{gift}}", this.gifts[this.giftID].name);

		this.$dialog.find("div.message span.msg").empty().text(message);
	}
}

class AdventGiftBlock extends GiftBlock
{
	protected TAG = "[GiftBlock]";

	constructor($root : JQuery,
	            gifts : GiftItem[],
	            perfID: number,
	            loggedIn: boolean
	)
	{
		super($root, gifts, perfID, loggedIn);
	}

	init()
	{
		super.init();
		this.$root.find(".gift-wrapper.gift-visible.gift-covered .cover").on("click", this.removeCover.bind(this));
	}

	removeCover(e)
	{
		let $cover = $(e.currentTarget);
		let $wrapper = $cover.parent(".gift-wrapper");
		let giftID = $wrapper.find(".gift").data("id");

		if (this.gifts[giftID].visible && this.gifts[giftID].covered) {
			$wrapper.removeClass("gift-covered");
			this.gifts[giftID].covered = false;

			let newCookie = [];
			for (let gid of Object.keys(this.gifts)) {
				let gift = this.gifts[gid];
				if (!gift.covered) {
					newCookie.push(gift.params.adventDay);
				}
			}
			cookie.create("advent_2016", newCookie.join(" "));
		}
	}
}

class ScrollableGiftBlock extends GiftBlock
{
	protected TAG = "[GiftBlock]";

	constructor($root : JQuery,
	            gifts : GiftItem[],
	            perfID: number,
	            loggedIn: boolean
	)
	{
		super($root, gifts, perfID, loggedIn);
	}

	init()
	{
		super.init();
		this.$root.find(".nav-left").on("click", () => this.scroll(-1));
		this.$root.find(".nav-right").on("click", () => this.scroll(1));
	}

	private page = 0;

	scroll(d)
	{
		if (d == 0) this.page = 0;

		let gop = Math.floor(this.$root.width() / this.$root.find(".gift-wrapper").width());

		let $list = this.$root.find(".gift-list");
		let gc = $list.find(".gift-wrapper").length;
		let gw = $list.find(".gift-wrapper:eq(2)").outerWidth() + 10;

		let infoSize = this.$root.find(".info-wrapper").length ? 2 : 0;

		let pages = Math.floor((gc + infoSize)/gop) - 1;

		this.page += d;
		if (this.page < 0) this.page = pages;
		if (this.page > pages) this.page = 0;

		let offset = gw * gop * this.page;
		$list.scrollLeft(offset);

		this.hideDialog();
	}

	remove()
	{
		this.$root.remove();
	}

	showDialogFor($gift: JQuery)
	{
		let gift = this.gifts[$gift.data("id")];
		this.giftID = gift.id;

		$gift.addClass("selected");

		// Create dialog
		this.$dialog = this.$root.find(".dialog-template").clone();

		this.$dialog
			.removeClass("dialog-template")
			.addClass("dialog");

		this.$root.append(this.$dialog);

		// Find gift position
		let arrowPos = $gift.parent().position().left + $gift.width() / 2;
		this.$dialog.find(".arrow").css("left", arrowPos);

		// Update data in the dialog
		let $title = this.$dialog.find("h4.title");
		$title.text($title.text().replace("{{gift}}", gift.name));

		// Purchase button
		let $purchase = this.$dialog.find(".button.purchase");

		$purchase.val(
			$purchase.val()
				.replace("{{gift}}", gift.name)
				.replace("{{price}}", gift.priceText)
		);

		$purchase.click(() =>
		{
			this.showContent("loading");
			let message = this.$dialog.find("textarea").val().trim();

			this.purchaseWrapper(() => {
				giftHandler.purchase(this.giftID, message, this.perfID, (r) => {
					this.showResult("gift", r.success, r.reason);
					creditDisplayHandler.update();
				});
			});
		});

		// OK and Cancel button acts same...
		this.$dialog.on("click", ".button.cancel, .button.ok", () => {this.hideDialog()});

		this.$dialog.find("img").attr("src", giftHandler.getImageURL(gift.id));
		this.$dialog.css("height", this.$dialog.find(".inner").outerHeight());

		this.showContent("message");
		this.$dialog.find("textarea").focus();
		this.$root.addClass("giftblock-open");

	}
}

class SmartToysGiftBlock extends ScrollableGiftBlock
{
	showDialogFor($gift: JQuery)
	{
		super.showDialogFor($gift);
		let pCat = $gift.data("pcat");

		let sec = 0;

		switch (pCat) {
			case 1: sec = 5; break;
			case 2: sec = 10; break;
			case 3: sec = 20; break;
			case 4: sec = 30; break;
			case 5: sec = 50; break;
		}

		let $title = this.$dialog.find("h4.title");
		$title.text($title.text().replace("{{sec}}", sec.toString()));
	}
}

class SmartToyWidget
{
	private TAG = "[SmartToyWidget]";

	private $widget : JQuery;
	private blocks : number;

	public static prices : number[] = [0,20,40,60,80,100];
	private selected: number;

	constructor(private $root : JQuery,
	            private perfID : number,
	            private loggedIn : boolean
	)
	{

		this.initWidget();
		this.initMoreDesc();

		this.$root.find("button.send").click(() =>
		{
			let price = SmartToyWidget.prices[this.selected];

			tipHandler.purchase(price, "", this.perfID, (r) =>
			{
				if (!this.loggedIn) {
					authHandler.showJoin();
					return;
				}
				creditDisplayHandler.update();
				if (r.success) {
				} else {
					this.showError(r.reason == "ooc" ? "ooc" : "technical");
				}
			}, "smarttoy");
		});
	}

	private onSent()
	{
		this.pulse(this.selected);
	}

	private pulse(i)
	{
		let $ghost = this.$root.find(".handle-ghost");

		$ghost.addClass("pulse");
		setTimeout(() => {
			$ghost.removeClass("pulse");
			setTimeout(() => {
				if (i > 1) this.pulse(i - 1);
			}, 100);
		}, 500);
	}

	private initMoreDesc()
	{
		this.$root.find("p.desc a.more").click(e => {
			e.preventDefault();
			this.showMoreDesc(true)
		});

		this.$root.find("p.desc a.less").click(e => {
			e.preventDefault();
			this.showMoreDesc(false)
		});

		this.showMoreDesc(false);
	}

	private showMoreDesc(show : boolean) {
		this.$root.find("p.desc a.more").css("display", !show ? "inline" : "none");
		this.$root.find("p.desc span.more").css("display", show ? "inline" : "none");
		this.$root.find("p.desc a.less").css("display", show ? "inline" : "none");
	}

	private showError(err)
	{
		if (err) {
			this.$root.find("button.send").hide();
			this.$root.find(".errors").show();
			this.$root.find(".errors .err").hide();
			this.$root.find(".errors .err-" + err).show();

			let t = setTimeout(() => {
				if (!t) return;
				this.showError(null);
				t = null;
			}, 5000);

			$(window).one("mousedown", () => {
				if (!t) return;
				this.showError(null);
				t = null;
			});

		} else {
			this.$root.find("button.send").show();
			this.$root.find(".errors").hide();
		}
	}

	private initWidget()
	{
		this.$widget = this.$root.find(".widget");
		this.blocks = this.$widget.find(".block").length;

		this.select(1);

		let onMouseMoveOrUp = (e) =>
		{
			let ww = this.$widget.width();
			let fromLeft = e.pageX - this.$widget.offset().left;
			let percent = Math.min(100, Math.max(0, fromLeft / ww * 100));
			let idx = Math.round(percent / 100 * this.blocks);
			idx = Math.min(this.blocks, Math.max(1, idx));
			this.select(idx);
		};

		this.$widget.on('mousedown', (e) =>
		{
			if (e.which != 1) return;

			$(document).on('mouseup.smarttoywidgetslider', (e) =>
			{
				$(document)
					.off('mouseup.smarttoywidgetslider')
					.off('mousemove.smarttoywidgetslider');

				onMouseMoveOrUp(e);
			});

			$(document).on('mousemove.smarttoywidgetslider', (e) =>
			{
				onMouseMoveOrUp(e);
			});
		});
	}

	public select(idx)
	{
		let $blocks = this.$widget.find(".block");

		for(let i = 0; i < this.blocks; i++) {
			let $b = $blocks.eq(i);
			$b[idx > i ? "addClass" : "removeClass"]("active");
		}

		let percent = idx / this.blocks * 100;

		let $bar = this.$widget.find(".bar");

		$bar.css({width: percent + "%"});
		if (percent === 100) $bar.addClass("full");
		else if (percent === 0) $bar.addClass("empty");
		else $bar.removeClass("empty full");

		let $price = this.$widget.find(".price");

		let value = creditCalculator.calc(SmartToyWidget.prices[idx]);
		let txt = $price.data("template").replace("{{value}}", value);
		$price.text(txt);
		this.selected = idx;
	}
}

class GiftWidget
{
	private TAG = "[GiftWidget]";

	private $dropdown     : JQuery;
	private $selected : JQuery;
	private $list : JQuery;

	private listOpen     : boolean = false;
	private phase        : string;
	private selectedType : string;
	private selectedID   : string;

	public chatMode     : boolean;
	public resetTimer   : number;

	public gifts: GiftItems = {};

	constructor(private perfID : number,
	            public normalGifts : GiftItems,
	            public specGifts : Array<GiftItems>,
	            private $root : JQuery)
	{
		debug.log(this.TAG, "[constructor]", normalGifts, specGifts);
		this.init();
		this.reset();
	}

	init()
	{
		Object["assign"](this.gifts, this.normalGifts);

		for (let grp of this.specGifts) {
			if (grp) Object["assign"](this.gifts, grp);
		}

		creditDisplayHandler.addOnUpdate((credit, response) => {
			this.updateTipList(response.maxTip, response.tips);
		});

		this.$dropdown = this.$root.find(".dropdown");
		this.$list = this.$dropdown.find(".list");
		this.$selected = this.$dropdown.find(".selected");

		this.$root.click(() => {
			if (this.phase == "result") {
				if (this.resetTimer) {
					clearTimeout(this.resetTimer);
					this.resetTimer = null;
				}
				this.reset();
			}
		});

		this.$selected.click((e) => {
			if (this.$dropdown.prop("disabled")) return;
			this.toggleList();
		});

		this.$list.on("click", ".item", (e) =>
		{
			var $node = $(e.currentTarget);
			this.selectedType = $node.data("type");

			if (this.selectedType == "tip-more") {
				this.showMoreTips();
			} else {
				this.selectedID = $node.data("id");
				var $nodeClone = $node.clone();
				//$nodeClone.find(".price").remove();
				this.$selected.empty().append($nodeClone).removeClass("focus");
				this.toggleList(false);
				this.askMessage();
			}
		});

		this.$root.find(".buttons input").click((e) =>
		{
			var message = this.$root.find(".textarea textarea").val().trim();
			this.setPhase("loading");

			if (this.selectedType == "tip") {
				tipHandler.purchase(this.selectedID, message, this.perfID, (r) =>
				{
					debug.log(this.TAG, "Ajax response", r);
					this.showResult("tip", r.success, r.reason);
					creditDisplayHandler.update();
				});
			}
			else
			{
				giftHandler.purchase(this.selectedID, message, this.perfID, (r) =>
				{
					debug.log(this.TAG, "Ajax response", r);
					this.showResult("gift", r.success, r.reason);
					creditDisplayHandler.update();
				});
			}
		});
	}

	toggleList(status: boolean = null)
	{
		this.listOpen = (status !== null) ? status : !this.listOpen;
		this.$list[this.listOpen ? "show" : "hide"]();
		this.$selected[this.listOpen ? "addClass" : "removeClass"]("focus");

		if (!this.listOpen) {
			this.$list.find("[data-type=tip].hide-default").hide();
			this.$list.find("[data-type=tip-more]").show();
		}
	}

	showMoreTips()
	{
		this.$list.find("[data-type=tip].hide-default").show();
		this.$list.find("[data-type=tip-more]").hide();
	}

	reset()
	{
		this.setPhase("normal");
		var empty = $("<div class=\"default\" />").text(this.$selected.data("default"));
		this.$selected.empty().append(empty);
		this.$root.find("textarea").empty().val("");
	}

	askMessage()
	{
		this.setPhase("message");
		var $input = this.$root.find(".buttons input");


		var text = $input.data("value-" + this.selectedType);
		if (this.selectedType === "gift") {
			text = text.replace("{{gift}}", this.gifts[this.selectedID].name)
		}
		$input.val(text);

		this.$root.find("textarea").focus();
	}

	setPhase(phase: string)
	{
		this.phase = phase;

		var loadingOrResult = phase === "loading" || phase === "result";

		this.$dropdown.prop("disabled", loadingOrResult);
		this.$root.find("textarea").prop("disabled", loadingOrResult);
		this.$root.find("input").prop("disabled", loadingOrResult);

		this.$root.find(".loading")[phase === "loading" ? "show" : "hide"]();
		this.$root.find(".result")[phase === "result" ? "show" : "hide"]();
		this.$root.find(".textarea")[phase !== "normal" ? "show" : "hide"]();

		this.$root.find(".buttons")[(phase !== "normal" && !loadingOrResult) ? "show" : "hide"]();
	}

	showResult(itemType, success, reason)
	{
		this.setPhase("result");
		var $dialog = this.$root.find(".result");

		if (success) {
			var message = $dialog.data(itemType + "-success");
		} else {
			var message = $dialog.data(itemType + "-" + reason);
			if (!message) message = $dialog.data(itemType + "-technical");
		}

		$dialog.find("p.message").empty().text(message);

		if (success) {
			// @ts-ignore
			this.resetTimer = setTimeout(() => this.reset(), 5000);
		}
	}

	getTipNode(id: string = null, price: number = null) : JQuery
	{
		var $template = this.$root.find(".item-template.tip");
		var nameText  = $template.find(".name").data("value-fixed");
		var priceText = $template.find(".price").data("value");

		if (price)
		{
			var $node = $template.clone()
				.removeClass("item-template")
				.addClass("item")
				.attr("data-id", id)
				.attr("data-type", "tip");

			$node.find(".name").text(nameText.replace("{{value}}", price));
			$node.find(".price").text(priceText.replace("{{value}}", price));
		}
		else
		{
			var $node = $template.clone()
				.attr("data-type", "tip-more")
				.attr("data-id", "tip-more")
				.removeClass("item-template")
				.addClass("item");

			$node.find(".name").text($template.find(".name").data("value-other"));
			$node.find(".price").html("...");
		}
		return $node
	}

	updateTipList(max, list)
	{
		var hasItems = list instanceof Array && list.length > 0;
		if (!hasItems) return;
		if (this.listOpen) return;

		var $tipContainer = this.$root.find(".tip-container");
		$tipContainer.empty();

		for (var i=0; i<list.length; i++)
		{
			var credits = list[i]["credits"];
			var currency = list[i]["currency"];

			var $node = this.getTipNode(credits, currency);
			if (list.length > 4 && i > 2) {
				$node.hide().addClass("hide-default");
			}

			$node.appendTo($tipContainer);
		}

		if (list.length > 4) {
			$tipContainer.append(this.getTipNode("more"))
		}
	}
}

var tipHandler =
{
	purchase: function(amount: number|string, message: string, perfID: number, callback=null, special : string = null): void
	{
		$.post(
			"/ajax/credit/sendtip", {amount: amount, perfID: perfID, message: message, special: special},
			function(r) {
				if (!callback) return;
				callback(r);
			}
		).error(function() {
			callback({success: false, reason: "technical"});
		})
	}
};

var giftHandler =
{
	getImageURL: function(giftID, ext = ".png")
	{
		// Flash can't handle protocol agonistic url-s so we fallback to https which is fine
		return "https:" + App.services.images.assetURL + "/gift/" + giftID + ext;
	},

	purchase: function (giftID: string, message: string, perfID: number, callback=null) : void
	{
		$.post(
			"/ajax/credit/sendgift",
			{giftID: giftID, perfID: perfID, message: message},
			function(r) {
				if (!callback) return;
				callback(r);
			}
		).error(function() {
			callback({success: false, reason: "technical"});
		})
	}
};

var membersChoiceHandler = {

	pid: null,
	current: null,
	container: null,

	init: function(container, list, perfid) {

		membersChoiceHandler.pid = perfid;
		membersChoiceHandler.container = container;

		if (typeof document.body.style.pointerEvents === 'undefined')
			this.container.find(".voteform").addClass('notmodern');

		container.on('click', '.send', function(e){membersChoiceHandler.send(e.target);});
		this.update(list);
	},

	dropDown: function() {
		membersChoiceHandler.container.find('.items').toggle();
	},

	getCurrent: function() {
		return this.container.find('.dropdown :selected').val();
	},

	setCurrent: function(value) {
		this.container.find('.dropdown option[value='+ value +']').attr('value');
	},

	update: function(list) {

		var current = membersChoiceHandler.getCurrent();
		if (typeof list === 'undefined') return;

		if (!list || list.length === 0 || !list[0].visible ) {
			membersChoiceHandler.container.find('.voteform').hide();
			membersChoiceHandler.container.find('.nocredit').show();
			membersChoiceHandler.container.find('.nocredit .votepopup').show();

		} else {
			membersChoiceHandler.container.find('.voteform').show();
			membersChoiceHandler.container.find('.nocredit').hide();
			membersChoiceHandler.container.find('.dropdown').empty();
			membersChoiceHandler.container.find('.dropdown').each(function(n,t) {

				var i, item;
				var foundCurrent = false;

				for (i=0; i<list.length; i++) {
					item = parseInt(list[i].votes);

					var text = $(t).data('template' + (item>1 ? '2' : ''));
					text = text.replace('{{count}}', item);
					if (list[i].visible) {
						$('<option />').attr('value', item).html('&nbsp;&nbsp;' + text).appendTo(this);
						if (item === current) foundCurrent = true;
					}
				}
				if (current && !foundCurrent) membersChoiceHandler.setCurrent(item);

			});
		}
	},

	popup: function(t, type, message = undefined) {

		if (t == 'replaced')
			this.replacedPopup(type, message);
		else
			this.delayedPopup(type, message);

	},

	delayedPopup: function(type, message) {

		debug.log('membersChoiceHandler::delayedPopup', type, message);

		var popup = $('#myPage').find('.votepopup');
		message = popup.data(type=='success' ? 'success' : message);

		popup
			.removeClass('success error')
			.addClass(type)
			.text(message)
			.show()
			.delay(3000)
			.fadeOut();
	},

	replacedPopup: function(type, message) {

		debug.log('membersChoiceHandler::replacedPopup', type, message);

		var $scrollPanel = $('.scrollPanel');

		var popup  = $scrollPanel.find('.votepopup');
		var popup2 = $scrollPanel.find('.votepopup2');

		message = popup.data(type == 'success' ? 'success' : message);

		var select = $scrollPanel.find(this.container).find('.dropdowncnt');
		var text =   $scrollPanel.find(this.container).find('.time');
		var button = $scrollPanel.find(this.container).find('.send');

		popup2.show().click(function() {
			popup.hide();
			popup2.hide();
			select.show();
			text.show();
			button.show();
			return false;
		});

		select.hide();
		button.hide();
		text.hide();

		popup
			.removeClass('success error')
			.addClass(type)
			.text(message)
			.show();

		popup2
			.text(popup2.data(type=='success' ? 'success' : 'error'))
			.show();

	},

	send: function(button) {

		var popupType;

		if ($(button).hasClass('inPanel')) popupType = 'replaced';
		else popupType = 'delayed';

		var current = membersChoiceHandler.getCurrent();
		debug.log('membersChoiceHandler::send', current);

		if (!current) return;

		var ajaxParams : any = {
			url: "/callback",
			method: "post",
			data: {command: 'vote', perfid: membersChoiceHandler.pid, votes: current},
			dataType: "json",

			success: (r) => {
				debug.log('membersChoiceHandler::send', r);
				if (r.success) {
					creditDisplayHandler.update();
					membersChoiceHandler.update(r.votes);
					membersChoiceHandler.popup(popupType, 'success');
				} else {
					membersChoiceHandler.popup(popupType, 'error', r.reason);
				}
			},
			error: (a,b,c) => {
				debug.log(a,b,c);
				membersChoiceHandler.popup(popupType, 'error', 'technical');
			}
		};

		$.ajax(ajaxParams)
	}
};
